import { EnumCacheEntityType } from "@/app/services/generated/enums/enumCacheEntityType.generated";
import api from "@/app/api";
import type { PackageType } from "@/app/services/generated/packagetypeService";
import {
  EntityWithGuidKeyCache,
  EntityCacheStore,
} from "@/app/caching/apiCache";
import { packageTypeService } from "@/app/services/extensions/packageTypeServiceExtended";

export interface IHasPackageTypesCache {
  packageTypes: PackageTypesCache;
}

// Singleton cache store
const packageTypesCacheStore = new EntityCacheStore<PackageType>(
  EnumCacheEntityType.packageType,
  async () => packageTypeService.getAllPackageTypes(api.tenantId)
);

// Ephemeral reader
export default class PackageTypesCache extends EntityWithGuidKeyCache<PackageType> {
  constructor() {
    super(packageTypesCacheStore, (x) => x.id);
  }
}
